<template>
  <div class="boardComponent">
    <b-card no-body>
      <b-card-header>
        Board
      </b-card-header>
      <b-card-body>
        <div class="cards">
          <div class="card" v-for="card in cards" :key="card">
            <Card :cardString="card" :height="110" />
          </div>
        </div>
        <b-input class="mt-3" :value="input" @input="updateInput" />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { cardsToString, stringToCards } from "../helpers/cards";
import Card from "./Card";

export default {
  name: "Board",
  components: { Card },
  data() {
    return {
      input: "",
    };
  },
  props: {
    // v-model value: card strings
    value: { type: Array, default: () => [] },
  },
  computed: {
    cards() {
      return this.value.slice(0, 5);
    },
  },
  methods: {
    updateInput(value) {
      this.input = value;
      this.$emit("input", stringToCards(this.input));
    },
  },
  created() {
    this.input = cardsToString(this.value);
  },
};
</script>

<style lang="scss" scoped>
.boardComponent {
  width: 500px;
}
.cards {
  display: flex;
}
.card {
  margin-right: 8px;
}
</style>
